import { createContext, useContext } from "react";

export const SiteContentContext = createContext(null);
export const useSiteContent = () => useContext(SiteContentContext);
export const useSiteCopy = () => {
  const content = useSiteContent();
  return {
    tx: (key, fallback) => content.text?.[key] ?? fallback,
    href: (key, fallback) => content.resolveLink?.(content.links?.[key] ?? fallback) || "",
  };
};
export const assetUrl = (value) => value?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${value}` : value;
export const phoneHref = (value) => `tel:${value.replace(/[^+0-9]/g, "")}`;
export const firstName = (owner) => owner.name.split(" ")[0].toLowerCase().replace(/^./, (c) => c.toUpperCase());

const rgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
const light = (hex) => rgb(hex).reduce((sum, n, i) => sum + (n / 255 <= .04045 ? n / 255 / 12.92 : ((n / 255 + .055) / 1.055) ** 2.4) * [.2126, .7152, .0722][i], 0) > .35;
export const siteTheme = ({ accent, background, surface }) => ({
  "--brand-accent": rgb(accent).join(" "),
  "--brand-deep": rgb(background).join(" "),
  "--brand-surface": rgb(surface).join(" "),
  "--brand-light": rgb(surface).map((x) => Math.min(255, x + 8)).join(" "),
  "--site-text": light(background) ? "#111827" : "#FFFFFF",
  "--site-muted": light(background) ? "#475569" : "#94A3B8",
  "--surface-text": light(surface) ? "#111827" : "#FFFFFF",
  "--surface-muted": light(surface) ? "#475569" : "#94A3B8",
  "--button-text": light(accent) ? "#050B14" : "#FFFFFF",
  "--chrome": light(background) ? "linear-gradient(#334155,#111827)" : "linear-gradient(180deg,#f8fafc 0%,#e2e8f0 38%,#64748b 52%,#cbd5e1 62%,#f1f5f9 100%)",
  "--surface-chrome": light(surface) ? "linear-gradient(#334155,#111827)" : "linear-gradient(180deg,#f8fafc 0%,#e2e8f0 38%,#64748b 52%,#cbd5e1 62%,#f1f5f9 100%)",
});

export const sectionLabels = { emergency: "Emergency banner", hero: "Main headline", marquee: "Scrolling message", services: "Services", trust: "License & trust badges", about: "About us", gallery: "Job gallery", reviews: "Customer reviews", areas: "Service area", owners: "Owner contacts", request: "Request form" };